import { ID } from "~/models/Identification"
import { JudgeResult } from "~/models/Judge"
import { PlanType } from "~/models/Plan"

export type ProductResult = Product & JudgeResult & {
  contract?: number,
  contractPlaceholder?: number,
  recommendContract?: number,
  checked?: boolean,
}

export type Price = {
  initialCost?: number, // 初期費用
  standardCost?: number, // 通常
  specialCost?: number, // 想定、必要かも？
  payBSCost?: number, // 従量
  amounts: { [PLAN in `${PlanType}`]: number }
}

export type Product = {
  id: ID,
  providerTenantId: string,
  name: string,
  categoryId: string,
  category: string,
  itemKind: string,
  price: Price,
  explain: string,
  options?: ID[],
  requiredOP?: string[],
  multiDiscount?: number,
  payBS?: boolean,
  contractServiceClassIdList?: string[]
}

export type ServiceProduct = Omit<ProductResult, keyof JudgeResult> & {
  id: ID,
  tags?: string[],
  detail?: string,
  includes?: ID[]
}

export type ProductResultList = {
  basicPack: ProductResult[],
  rolePack: ProductResult[],
  basicFnc: ProductResult[],
  addFnc: ProductResult[],
  pygFnc: ProductResult[],
  dataFnc: ProductResult[],
} & {
  [CATEGORY_ID: string]: ProductResult[],
}

export type CsvProduct = Product & {
  point: string,
  description: string,
  modalType: number,
  selected: number,
  htmlKey: string,
  sort?: number
  requiredModalExplanation?: string
  uncheckExplanation?: string
  condition: string,
  section1: number,
  section2: number,
}

export type SimpleProductResultList = {
  ssBasic: CsvProduct[],
  reBasic: CsvProduct[],
  coBasic: CsvProduct[],
  staff: CsvProduct[],
  planning: CsvProduct[],
  performance: CsvProduct[],
  dx: CsvProduct[],
  marketing: CsvProduct[],
  database: CsvProduct[],
  maintenanceSup: CsvProduct[],
  edBasic: CsvProduct[],
  edMaintenanceSup: CsvProduct[],
  ppBasic: CsvProduct[], // プライスボード作成支援サービス基本パック
  mpBasic: CsvProduct[], // マーケットプレイス基本パック
  common: CsvProduct[],
  payBasic: CsvProduct[],
}

export type ProductCategory = keyof ProductResultList
export type SimpleProductCategory = keyof SimpleProductResultList

export enum FirstSection {
  // 基本サービス（整備、SS、車販、板金）
  Basic = 1,
  // 従業員パック
  Staff = 2,
  // 3：提案力強化のためのオプション
  Planning = 3,
  // 4：生産性強化のためのオプション
  Performance = 4,
  // 5：DX推進のためのオプション
  DigitalTransformation = 5,
  // 6：集客強化のためのオプション
  Marketing = 6,
  // 7：データベース
  Database = 7,
  // 8：メンテナンスサポート
  MaintenanceSupport = 8,
  // 9：初期導入支援（全業種共通）
  IntroductionSupport = 9,
  // 10：電帳.DX向け商品
  Dencho = 10,
  // 11：メンテナンスサポート・初期導入支援（電帳向け）
  DenchoSupport = 11,
  // 12：プライスボード作成支援サービス向け商品
  PricePrint = 12,
  // 13：マーケットプレイス
  MarketPlace = 13,
  // 14：共通オプション
  Shared = 14,
  // 15：BloadLeaf Pay
  BroadLeafPay = 15,
}

export enum SecondSection {
  Any = 0,
  Maintenance = 1,
  Repair = 2,
  Shared = 3,
  CarSales = 4,
  None = 99,
}
